export const getNameInitials = item => {
  let initials =
    item &&
    item.firstName &&
      item.lastName &&
      item.firstName[0]?.substring(0, 1).toUpperCase() +
        item.lastName[0]?.substring(0, 1).toUpperCase();
  return initials;
};
